// extracted by mini-css-extract-plugin
module.exports = {"financeVideo":"financeVideo-10FmNfZo","current":"current-3rbcwlZG","pic_img":"pic_img-3zcHqsYe","trans":"trans-j3sw6khS","text":"text-2B9sTBKE","title":"title-i9NPg88y"};